import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ReportIcon } from "src/components/ui-icons/card/ReportIcon";
import GroupIcon from "src/components/ui-icons/reports/GroupIcon";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import ExportToExcel from "src/modules/exelExport";
import { LayoutWithAsideAndContent } from "src/pages/LayoutWithAsideAndContent";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import Loading from "src/components/Loading";
import { selectItems } from "src/modules/spItems/selectors";
import {
  activityAnalysisListName,
  collectionsListName,
  departmentsListName,
  dependenciesListName,
  linesListName,
  MDWorkstationListName,
  myDocumentsEmployeeReportRelationsListName,
  myDocumentsListName,
  processesListName,
  sectorsListName,
  siteUrl,
  statusesListName,
  typesListName,
} from "src/api/config";
import { getItemsRequest } from "src/modules/spItems/api";
import _, { isObject } from "lodash";
import moment from "moment";
import LoadingOpBg from "src/components/LoadingOpBg";
import Form from "src/components/Form";
import {
  notificationsListName,
  templatesOWDListName,
} from "src/api/config/notifications.config";
import { addUsers } from "src/modules/users/actions";
import DownloadEmployesTable from "src/components/tables/DownloadEmployesTable";
import { twMerge } from "tailwind-merge";
import { docStatuses, notificationStatuses } from "src/api/config/systemSwitch";
import { selectCurrentUser } from "src/modules/users/selector";
import { FavoriteButtonFilters } from "src/modules/favoriteFilters/md/FavoriteButtonFilters";
import { FavoriteFiltersList } from "src/modules/favoriteFilters/md/FavoriteFiltersList";
import AuditEmplyeesTable from "src/components/tables/AuditEmplyeesTable";
import OwdEmployeesTable from "src/components/tables/OwdEmployeesTable";
import Button from "src/components/Button";
import { Modal } from "src/components/DialogComponent";
import { exportExcelFile } from "src/modules/exelExport/exelExport";

function EmployeesReportFilters({
  setFilters,
  setGetListDocuments,
  setLocalFilters,
  typeReport,
  setFiltersParams,
  filtersParams,
  defaultUserFilter,
  userFilterCheck,
  reRenderUserFilter,
  setDisplayFilters
}: any) {
  const [defaultValues, setDefaultValues] = useState({});
  const [workplaces, setWorkplaces] = useState<any>([]);
  const [fields, setFields] = useState<any>([
    {
      type: "peoplePicker",
      require: false,
      single: true,
      isFilter: true,
      key: "ReportEmployee",
      title: "Сотрудник",
      current: false,
      placeholder: "Введите имя или фамилию",
      width: "w-full",
    },
    {
      type: "dateRange",
      require: false,
      key: "DateForReport",
      title: "Дата скачивания документа",
      isFilter: true,
      placeholder: "дд.мм.гггг",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Status",
      isFilter: true,
      title: "Статус документа",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Collection",
      isFilter: true,
      searchInFilterCheckbox: true,
      title: "Коллекция",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Department",
      isFilter: true,
      searchInFilterCheckbox: true,
      title: "Подразделения/Функция",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Sector",
      searchInFilterCheckbox: true,
      isFilter: true,
      title: "Колонна/Направление/Отдел",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Process",
      searchInFilterCheckbox: true,
      title: "Блок колонны/Участок",
      isFilter: true,
      placeholder: "Не выбрано",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "DocType",
      searchInFilterCheckbox: true,
      isFilter: true,
      title: "Тип документа",
      placeholder: "Не выбрано",
      width: "w-full",
    },
    {
      type: "checkbox",
      isFilter: true,
      require: false,
      title: "Рабочее место",
      key: "WorkPlaces",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Lines",
      searchInFilterCheckbox: true,
      isFilter: true,
      title: "Линия розлива",
      placeholder: "Не выбрано",
      width: "w-full",
    },
    {
      type: "radio",
      require: false,
      key: "Critical",
      isFilter: true,
      title: "Критичность",
      width: "w-full",
    },
    {
      type: "checkbox_search",
      require: false,
      isFilter: true,
      title: "Название оборудования",
      searchApiField: "Title",
      key: "Equipments_Title",
      placeholder: "Введите название",
      width: "w-full",
    },
    {
      type: "checkbox_search",
      require: false,
      title: "Производитель оборудования",
      key: "Equipments_Manufacturer",
      searchApiField: "Manufacturer",
      isFilter: true,
      placeholder: "Введите производителя",
      width: "w-full",
    },
    {
      type: "checkbox_search",
      require: false,
      title: "Модель оборудования",
      key: "Equipments_Model",
      searchApiField: "Model",
      isFilter: true,
      placeholder: "Введите модель",
      width: "w-full",
    },
    {
      type: "checkbox_search",
      require: false,
      title: "Тип оборудования",
      key: "Equipments_TypeEquipment",
      searchApiField: "TypeEquipment",
      isFilter: true,
      placeholder: "Введите тип",
      width: "w-full",
    },
    {
      type: "checkbox_search",
      require: false,
      title: "SAP № технического места",
      key: "Equipments_SAP",
      searchApiField: "SAP",
      isFilter: true,
      placeholder: "Введите SAP",
      width: "w-full",
    },
    {
      type: "peoplePicker",
      require: false,
      single: true,
      isFilter: true,
      key: "ResponsibleForRevisionEmail",
      title: "Ответственный за пересмотр",
      current: false,
      placeholder: "Введите имя или фамилию",
      width: "w-full",
    },
    {
      type: "peoplePicker",
      require: false,
      single: true,
      isFilter: true,
      key: "AuthorEmail",
      title: "Создатель",
      current: false,
      placeholder: "Введите имя или фамилию",
      width: "w-full",
    },
    {
      type: "dateRange",
      require: false,
      key: "DateForRevision",
      title: "Пересмотр документа",
      isFilter: true,
      placeholder: "дд.мм.гггг",
      width: "w-full",
    }
  ]);
  const [reportDocumentsFilter, setReportDocumentsFilter] = useState<any>({});

  const [dependenceFields, setDependenceFields] = useState<any>({
    Collection: null,
    Department: null,
    Sector: null,
    Process: null,
  });

  const collections: any = useAppSelector((state) =>
    selectItems(state, collectionsListName)
  );
  const departments: any = useAppSelector((state) =>
    selectItems(state, departmentsListName)
  );
  const sectors: any = useAppSelector((state) =>
    selectItems(state, sectorsListName)
  );
  const processes: any = useAppSelector((state) =>
    selectItems(state, processesListName)
  );
  const types: any = useAppSelector((state) =>
    selectItems(state, typesListName)
  );
  const lines: any = useAppSelector((state) =>
    selectItems(state, linesListName)
  );
  const statuses: any = useAppSelector((state) =>
    selectItems(state, statusesListName)
  );

  const [customLoading, setCustomLoading] = useState(true);
  const [resetFilters, setResetFiters] = useState(false);
  const [isDefaultDepartment, setDefaultDepartment] = useState(0);
  const currentUser = useAppSelector((state) => selectCurrentUser(state));

  useEffect(() => {
    getItemsRequest({
      listName: MDWorkstationListName
    }).then((result) => {
      setWorkplaces([...result.items]);
    })
  }, []);

  useEffect(() => {
    let tempFields = [...fields];
    if (typeReport === "owd") {
      tempFields = [...[
        {
          type: "peoplePicker",
          require: false,
          single: true,
          isFilter: true,
          key: "AuthorEmailOWD",
          title: "Кем назначено OWD",
          current: false,
          placeholder: "Введите имя или фамилию",
          width: "w-full",
        },
        {
          type: "peoplePicker",
          require: false,
          single: true,
          isFilter: true,
          key: "TestedEmployee",
          title: "Кому провели OWD",
          current: false,
          placeholder: "Введите имя или фамилию",
          width: "w-full",
        },
      ], ...tempFields];
      tempFields = tempFields.map(field => {
        if (field.key === 'ReportEmployee') {
          field.title = 'Кто провёл OWD'
        }
        if (field.key === 'DateForReport') {
          field.title = 'Дата факта проведения OWD'
        }
        return field
      });
    } else {
      tempFields = tempFields.filter(field => field.key !== 'AuthorEmailOWD' && field.key !== 'TestedEmployee');
      tempFields = tempFields.map(field => {
        if (field.key === 'ReportEmployee') {
          field.title = 'Сотрудник'
        }
        if (typeReport === 'download' && field.key === 'DateForReport') {
          field.title = 'Дата скачивания документа'
        }
        if (typeReport === 'audit' && field.key === 'DateForReport') {
          field.title = 'Дата факта ознакомления'
        }
        return field
      });
    }
    setFields([...tempFields]);
  }, [typeReport]);

  //Формируем данные фильтры по умолчанию
  useEffect(() => {
    setCustomLoading(true)
    const tempFieldsForm = [...fields];
    for (let i = 0; i < tempFieldsForm.length; i++) {
      if (tempFieldsForm[i]["key"] === "Collection") {
        tempFieldsForm[i]["optionsInputs"] = collections.map((collection: any) => {
          return {
            id: collection.ID,
            name: collection.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "Status") {
        tempFieldsForm[i]["optionsInputs"] = statuses.filter(status => status.ID === docStatuses.revision || status.ID === docStatuses.review || status.ID === docStatuses.cancel || status.ID === docStatuses.approval || status.ID === docStatuses.archive || status.ID === docStatuses.public).map(
          (status: any) => {
            return {
              id: status.ID,
              name: status.Title,
              disabled: false,
            };
          }
        );
      }
      if (tempFieldsForm[i]["key"] === "Department") {
        tempFieldsForm[i]["optionsInputs"] = departments.map((department: any) => {
          return {
            id: department.ID,
            name: department.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "Sector") {
        tempFieldsForm[i]["optionsInputs"] = sectors.map((sector: any) => {
          return {
            id: sector.ID,
            name: sector.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "Process") {
        tempFieldsForm[i]["optionsInputs"] = processes.map((process: any) => {
          return {
            id: process.ID,
            name: process.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "DocType") {
        tempFieldsForm[i]["optionsInputs"] = types.map((type: any) => {
          return {
            id: type.ID,
            name: type.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "Lines") {
        tempFieldsForm[i]["optionsInputs"] = lines.map((line: any) => {
          return {
            id: line.ID,
            name: line.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "WorkPlaces") {
        tempFieldsForm[i]["optionsInputs"] = workplaces.map((place: any) => {
          return {
            id: place.ID,
            name: `${place.Location.get_lookupValue()}_${place.Workstation}`,
            disabled: false,
          };
        }).sort((a, b) => a.name.localeCompare(b.name, 'ru', { sensitivity: 'base' }));
      }
      if (tempFieldsForm[i]["key"] === "Critical") {
        tempFieldsForm[i]["optionsInputs"] = ["Критичный", "Не критичный"];
      }
    }
    setFields([...tempFieldsForm]);
    setCustomLoading(false);
  }, [collections, departments, sectors, processes, types, lines, workplaces, statuses]);

  useEffect(() => {
    if (Object.keys(currentUser).length > 0 && currentUser.id > 0) {
      setCustomLoading(true);
      let filtersDependDocuments: any = {};
      const tempFieldsForm = [...fields];
      Object.keys(dependenceFields).map((key) => {
        for (let i = 0; i < tempFieldsForm.length; i++) {
          if (tempFieldsForm[i]["key"] === key) {
            tempFieldsForm[i]["optionsInputs"] = tempFieldsForm[i]["optionsInputs"].map((option: any) => {
              return {
                id: option.id,
                name: option.name,
                disabled: false,
              };
            });
          }
        }
      });
      if (dependenceFields["Collection"]) {
        for (let i = 0; i < tempFieldsForm.length; i++) {
          if (tempFieldsForm[i]["key"] === "Lines") {
            tempFieldsForm[i]["optionsInputs"] = lines
              .filter((line: any) =>
                dependenceFields["Collection"].some((depend: any) => depend.id === line.Collection.ID)
              )
              .map((line: any) => {
                return {
                  id: line.ID,
                  name: line.Title,
                  disabled: false,
                };
              });
          }
        }
      }
      Object.keys(dependenceFields).map((key) => {
        if (dependenceFields[key] && dependenceFields[key].length > 0) {
          filtersDependDocuments[key] = dependenceFields[key].map((item: any) => item.id);
        }
      });
      if (Object.keys(filtersDependDocuments).length === 0) {
        setFields([...tempFieldsForm]);
        setCustomLoading(false);
      } else {
        if (Object.keys(filtersDependDocuments).length > 0) {
          setCustomLoading(true);
          //Устанавливаем зависимости в фильтрах
          getItemsRequest({
            listName: dependenciesListName,
            filters: filtersDependDocuments,
            filtersType: "or",
            sortOrder: { name: "SortDepend", asc: true },
          }).then((results) => {
            const dependDocuments = [...results.items];
            const collectionIds = _.uniqWith(
              dependDocuments.map((item: any) => item.Collection.get_lookupId()),
              _.isEqual
            );
            const departmentIds = _.uniqWith(
              dependDocuments.map((item: any) => item.Department.get_lookupId()),
              _.isEqual
            );
            const sectorIds = _.uniqWith(
              dependDocuments.map((item: any) => item.Sector.get_lookupId()),
              _.isEqual
            );
            const processIds = _.uniqWith(
              dependDocuments.map((item: any) => item.Process.get_lookupId()),
              _.isEqual
            );
            for (let i = 0; i < tempFieldsForm.length; i++) {
              if (tempFieldsForm[i]["key"] === "Collection") {
                if (!filtersDependDocuments["Collection"] || Object.keys(filtersDependDocuments).length > 1) {
                  tempFieldsForm[i]["optionsInputs"] = collections.map((collection: any) => {
                    return {
                      id: collection.ID,
                      name: collection.Title,
                      disabled: false, //collectionIds.indexOf(collection.ID) === -1,
                      hide: collectionIds.indexOf(collection.ID) === -1
                    };
                  });
                }
              }
              if (tempFieldsForm[i]["key"] === "Department") {
                if (!filtersDependDocuments["Department"] || Object.keys(filtersDependDocuments).length > 1) {
                  tempFieldsForm[i]["optionsInputs"] = departments.map((department: any) => {
                    return {
                      id: department.ID,
                      name: department.Title,
                      disabled: false, //departmentIds.indexOf(department.ID) === -1,
                      hide: departmentIds.indexOf(department.ID) === -1,
                      user_Department: department.User_Department
                    };
                  });
                  tempFieldsForm[i]["optionsInputs"].forEach((department: any) => {
                    if (
                      department.user_Department &&
                      department.user_Department.indexOf(currentUser.department) !== -1 &&
                      department.disabled
                    ) {
                      setDefaultDepartment(department.id);
                    }
                  });
                }
              }
              if (tempFieldsForm[i]["key"] === "Sector") {
                if (!filtersDependDocuments["Sector"] || Object.keys(filtersDependDocuments).length > 1) {
                  tempFieldsForm[i]["optionsInputs"] = sectors.map((sector: any) => {
                    return {
                      id: sector.ID,
                      name: sector.Title,
                      disabled: false, //sectorIds.indexOf(sector.ID) === -1,
                      hide: sectorIds.indexOf(sector.ID) === -1,
                    };
                  });
                }
              }
              if (tempFieldsForm[i]["key"] === "Process") {
                if (!filtersDependDocuments["Process"] || Object.keys(filtersDependDocuments).length > 1) {
                  tempFieldsForm[i]["optionsInputs"] = processes.map((process: any) => {
                    return {
                      id: process.ID,
                      name: process.Title,
                      disabled: false, //processIds.indexOf(process.ID) === -1,
                      hide: processIds.indexOf(process.ID) === -1
                    };
                  });
                }
              }
            }
            setFields([...tempFieldsForm]);
            setCustomLoading(false);
          });
        }
      }
    }
  }, [dependenceFields, currentUser]);

  useEffect(() => {
    setDependenceFields({
      Collection: null,
      Department: null,
      Sector: null,
      Process: null,
    });
  }, [resetFilters]);

  useEffect(() => {
    if (Object.keys(reportDocumentsFilter).length > 0) {
      const existsFiltersDocuments: any = {};
      Object.keys(reportDocumentsFilter).map((key) => {
        if (reportDocumentsFilter[key]) {
          if (Array.isArray(reportDocumentsFilter[key])) {
            if (reportDocumentsFilter[key].length > 0) {
              existsFiltersDocuments[key] = reportDocumentsFilter[key];
            }
          } else if (isObject(reportDocumentsFilter[key])) {
            if (Object.keys(reportDocumentsFilter[key]).length > 0) {
              existsFiltersDocuments[key] = reportDocumentsFilter[key];
            }
          } else {
            existsFiltersDocuments[key] = reportDocumentsFilter[key];
          }
        }
      });
      const tempFilters: any = {};
      const tempDisplayFilters: any = {};
      console.log("existsFiltersDocuments: ", existsFiltersDocuments);
      setLocalFilters({});
      Object.keys(existsFiltersDocuments).map((key) => {
        if (key === "DateForRevision") {
          tempFilters[key] = {
            start:
              (existsFiltersDocuments[key] &&
                moment(existsFiltersDocuments[key].startDate).isValid() &&
                moment(existsFiltersDocuments[key].startDate).format(
                  "YYYY-MM-DD"
                )) ||
              null,
            end:
              (existsFiltersDocuments[key] &&
                moment(existsFiltersDocuments[key].endDate).isValid() &&
                moment(existsFiltersDocuments[key].endDate).format(
                  "YYYY-MM-DD"
                )) ||
              null,
          };
          tempDisplayFilters[key] = `Дата пересмотра от ${moment(
            existsFiltersDocuments[key].startDate
          ).format("DD.MM.YYYY")} до ${moment(
            existsFiltersDocuments[key].endDate
          ).format("DD.MM.YYYY")}`;
        } else if (key === "DateForReport") {
          setLocalFilters((prevState) => {
            return {
              ...prevState, ...{
                [key]: {
                  start:
                    (existsFiltersDocuments[key] &&
                      moment(existsFiltersDocuments[key].startDate).isValid() &&
                      moment(existsFiltersDocuments[key].startDate).format(
                        "YYYY-MM-DD"
                      )) ||
                    null,
                  end:
                    (existsFiltersDocuments[key] &&
                      moment(existsFiltersDocuments[key].endDate).isValid() &&
                      moment(existsFiltersDocuments[key].endDate).format(
                        "YYYY-MM-DD"
                      )) ||
                    null,
                }
              }
            }
          });
          if (typeReport === 'audit') {
            tempDisplayFilters[key] = `Дата факта ознакомления от ${moment(
              existsFiltersDocuments[key].startDate
            ).format("DD.MM.YYYY")} до ${moment(
              existsFiltersDocuments[key].endDate
            ).format("DD.MM.YYYY")}`;
          }
          if (typeReport === 'owd') {
            tempDisplayFilters[key] = `Дата факта проведения OWD от ${moment(
              existsFiltersDocuments[key].startDate
            ).format("DD.MM.YYYY")} до ${moment(
              existsFiltersDocuments[key].endDate
            ).format("DD.MM.YYYY")}`;
          }
          if (typeReport === 'download') {
            tempDisplayFilters[key] = `Дата скачивания документа от ${moment(
              existsFiltersDocuments[key].startDate
            ).format("DD.MM.YYYY")} до ${moment(
              existsFiltersDocuments[key].endDate
            ).format("DD.MM.YYYY")}`;
          }
        } else if (
          key === "Collection" ||
          key === "Department" ||
          key === "Sector" ||
          key === "Process" ||
          key === "Lines" ||
          key === "DocType" ||
          key === "WorkPlaces" ||
          key === "Status"
        ) {
          tempFilters[key] = existsFiltersDocuments[key].map(
            (item: any) => item.id
          );
          tempDisplayFilters[key] = existsFiltersDocuments[key].map(
            (item: any) => item.name
          );
        } else if (
          key === "AuthorEmail" ||
          key === "ResponsibleForRevisionEmail"
        ) {
          tempFilters[key] = `${existsFiltersDocuments[key][0]["value"]}*`;
          tempDisplayFilters[key] = existsFiltersDocuments[key][0]["label"];
        } else if (key === "Critical") {
          tempFilters[key] =
            (existsFiltersDocuments[key] === "Критичный" && true) || false;
          tempDisplayFilters[key] = existsFiltersDocuments[key];
        } else if (
          key === "Equipments_Title" ||
          key === "Equipments_Manufacturer" ||
          key === "Equipments_Model" ||
          key === "Equipments_TypeEquipment" ||
          key === "Equipments_SAP"
        ) {
          if (!Array.isArray(tempFilters["Equipments"])) {
            tempFilters["Equipments"] = [];
          }
          tempFilters["Equipments"] = [
            ...tempFilters["Equipments"],
            ...existsFiltersDocuments[key].map(
              (equipment: any) => `${equipment.id}*`
            ),
          ];
          tempDisplayFilters[key] = existsFiltersDocuments[key].map(
            (equipment: any) => `${equipment.name}`
          );
        } else if (key === "ReportEmployee" || key === "AuthorEmailOWD" || key === "TestedEmployee") {
          setLocalFilters((prevState) => {
            return {
              ...prevState, ...{ [key]: existsFiltersDocuments[key][0]["value"] }
            }
          });
          tempDisplayFilters[key] = existsFiltersDocuments[key][0]["label"];
        }
      });
      setDisplayFilters({ ...tempDisplayFilters });
      setFilters({ ...tempFilters });
      const tempExistsFiltersDocuments = { ...existsFiltersDocuments };
      tempExistsFiltersDocuments.hasOwnProperty('ReportEmployee') && delete tempExistsFiltersDocuments['ReportEmployee'];
      tempExistsFiltersDocuments.hasOwnProperty('AuthorEmailOWD') && delete tempExistsFiltersDocuments['AuthorEmailOWD'];
      tempExistsFiltersDocuments.hasOwnProperty('TestedEmployee') && delete tempExistsFiltersDocuments['TestedEmployee'];
      tempExistsFiltersDocuments.hasOwnProperty('DateForReport') && delete tempExistsFiltersDocuments['DateForReport'];
      if (
        JSON.stringify(filtersParams) !== JSON.stringify(tempExistsFiltersDocuments)
      ) {
        setFiltersParams(tempExistsFiltersDocuments);
      }
    }
  }, [reportDocumentsFilter]);

  useEffect(() => {
    if (collections.length > 0 && Object.keys(currentUser).length > 0 && currentUser.id > 0 && userFilterCheck && statuses.length > 0 && departments.length > 0) {
      let defaultObj: any = {};
      if (Object.keys(filtersParams).length > 0) {
        Object.keys(filtersParams).forEach(key => {
          if (filtersParams[key]) {
            defaultObj[key] = filtersParams[key];
          } else {
            defaultObj[key] = null;
          }
        });
        defaultObj['DateForReport'] = reportDocumentsFilter && reportDocumentsFilter['DateForReport'] || {
          startDate: moment().startOf("month").format('YYYY-MM-DDT00:00:00'),
          endDate: moment().endOf("month").format('YYYY-MM-DDT23:59:59')
        };
        setDefaultValues(defaultObj);
      } else if (defaultUserFilter && Object.keys(JSON.parse(defaultUserFilter.MDFullFilters)).length > 0) {
        Object.keys(JSON.parse(defaultUserFilter.MDFullFilters)).forEach(key => {
          if (JSON.parse(defaultUserFilter.MDFullFilters)[key]) {
            defaultObj[key] = JSON.parse(defaultUserFilter.MDFullFilters)[key];
          } else {
            defaultObj[key] = null;
          }
        });
        defaultObj['DateForReport'] = reportDocumentsFilter && reportDocumentsFilter['DateForReport'] || {
          startDate: moment().startOf("month").format('YYYY-MM-DDT00:00:00'),
          endDate: moment().endOf("month").format('YYYY-MM-DDT23:59:59')
        };
        setDefaultValues(defaultObj);
      } else {
        let defaultLocationsIds: number[] = [];
        if (currentUser.isCollectionAdmin || currentUser.isCollectionEditor) {
          if (Array.isArray(currentUser.isCollectionAdmin) && currentUser.isCollectionAdmin.length > 0) {
            defaultLocationsIds = [...defaultLocationsIds, ...currentUser.isCollectionAdmin];
          }
          if (Array.isArray(currentUser.isCollectionEditor) && currentUser.isCollectionEditor.length > 0) {
            defaultLocationsIds = [...defaultLocationsIds, ...currentUser.isCollectionEditor];
          }
        }
        let unicDefaultLocationsIds: number[] = [..._.uniqWith(defaultLocationsIds, _.isEqual)];
        setDependenceFields({
          Collection: unicDefaultLocationsIds.length > 0 && unicDefaultLocationsIds.map(id => {
            return { id: id, name: collections.find((collection: any) => collection.ID === id)['Title'], disabled: false }
          }) || null,
          Department: null,
          Sector: null,
          Process: null
        });
        fields.map((field: any) => {
          if (field.key === "Collection") {
            defaultObj[field.key] = unicDefaultLocationsIds.length > 0 && unicDefaultLocationsIds.map(id => {
              return { id: id, name: collections.find((collection: any) => collection.ID === id)['Title'], disabled: false }
            }) || null;
          } else if (field.key === "DateForReport") {
            defaultObj[field.key] = {
              startDate: moment().startOf("month").format('YYYY-MM-DDT00:00:00'),
              endDate: moment().endOf("month").format('YYYY-MM-DDT23:59:59')
            };
          } else if (field.key === "Department") {
            defaultObj[field.key] =
              departments
                .filter(
                  (department: any) =>
                    currentUser.department &&
                    department.User_Department &&
                    department.User_Department.indexOf(currentUser.department) !== -1,
                )
                .map((department: any) => {
                  return { id: department.ID, name: department.Title, disabled: false };
                }) || null;
          } else if (field.key === "Status") {
            defaultObj[field.key] = [
              {
                id: docStatuses.public,
                name: 'Опубликован',
                disabled: false
              },
              {
                id: docStatuses.review,
                name: 'На пересмотр',
                disabled: false
              }
            ]
          } else {
            defaultObj[field.key] = null;
          }
        });
        setDefaultValues(defaultObj);
      }
    }
  }, [resetFilters, collections, JSON.stringify(currentUser), userFilterCheck, reRenderUserFilter, statuses, departments]);

  // useEffect(() => {
  //   if (isDefaultDepartment) {
  //     setDefaultValues((prevState) => {
  //       return { ...prevState, Department: null }
  //     });
  //   }
  // }, [isDefaultDepartment]);

  return (
    <FlexCol className="relative">
      {customLoading && <LoadingOpBg />}
      {Object.keys(reportDocumentsFilter).length > 0 &&
        Object.keys(reportDocumentsFilter).some(
          (key) => reportDocumentsFilter[key]
        ) && (
          <div
            onClick={() => {
              setFiltersParams({});
              setReportDocumentsFilter({});
              setFilters({});
              setLocalFilters({});
              setResetFiters(!resetFilters);
              setGetListDocuments(false);
            }}
            className="p-5 flex flex-row group items-center text-[14px] text-[#637381] cursor-pointer gap-x-2 flex-nowrap border-b"
          >
            <div className="flex flex-col">Сбросить фильтры</div>
            <div className="flex flex-col pt-1">
              <svg
                width="16"
                height="16"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_33_4954)">
                  <path
                    d="M5.9998 5.39995L1.4248 0.824951C1.25605 0.656201 0.993555 0.656201 0.824805 0.824951C0.656055 0.993701 0.656055 1.2562 0.824805 1.42495L5.3998 5.99995L0.824805 10.575C0.656055 10.7437 0.656055 11.0062 0.824805 11.175C0.993555 11.3437 1.25605 11.3437 1.4248 11.175L5.9998 6.59995L10.5748 11.175C10.7436 11.3437 11.0061 11.3437 11.1748 11.175C11.2498 11.1 11.3061 10.9875 11.3061 10.875C11.3061 10.7625 11.2686 10.65 11.1748 10.575L6.5998 5.99995L11.1748 1.42495C11.2498 1.34995 11.3061 1.23745 11.3061 1.12495C11.3061 1.01245 11.2686 0.899951 11.1748 0.824951C11.0061 0.656201 10.7436 0.656201 10.5748 0.824951L5.9998 5.39995Z"
                    fill="#637381"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_33_4954">
                    <rect
                      width="16"
                      height="16"
                      fill="white"
                      transform="translate(0 12) rotate(-90)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        )}
      <Form
        type="report_documents_filters"
        setFormData={setReportDocumentsFilter}
        fieldsForm={fields}
        defaultValues={defaultValues}
        setDependenceFields={setDependenceFields}
      />
      {Object.keys(reportDocumentsFilter).length > 0 &&
        Object.keys(reportDocumentsFilter).some(
          (key) => reportDocumentsFilter[key]
        ) && (
          <div
            onClick={() => {
              setFiltersParams({});
              setReportDocumentsFilter({});
              setFilters({});
              setLocalFilters({});
              setResetFiters(!resetFilters);
              setGetListDocuments(false);
            }}
            className="p-5 flex flex-row group items-center text-[12px] text-[#637381] cursor-pointer gap-x-2 flex-nowrap"
          >
            <div className="flex flex-col group-hover:underline">
              Сбросить фильтры
            </div>
            <div className="flex flex-col pt-1">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_33_4954)">
                  <path
                    d="M5.9998 5.39995L1.4248 0.824951C1.25605 0.656201 0.993555 0.656201 0.824805 0.824951C0.656055 0.993701 0.656055 1.2562 0.824805 1.42495L5.3998 5.99995L0.824805 10.575C0.656055 10.7437 0.656055 11.0062 0.824805 11.175C0.993555 11.3437 1.25605 11.3437 1.4248 11.175L5.9998 6.59995L10.5748 11.175C10.7436 11.3437 11.0061 11.3437 11.1748 11.175C11.2498 11.1 11.3061 10.9875 11.3061 10.875C11.3061 10.7625 11.2686 10.65 11.1748 10.575L6.5998 5.99995L11.1748 1.42495C11.2498 1.34995 11.3061 1.23745 11.3061 1.12495C11.3061 1.01245 11.2686 0.899951 11.1748 0.824951C11.0061 0.656201 10.7436 0.656201 10.5748 0.824951L5.9998 5.39995Z"
                    fill="#637381"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_33_4954">
                    <rect
                      width="12"
                      height="12"
                      fill="white"
                      transform="translate(0 12) rotate(-90)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        )}
    </FlexCol>
  );
}

export function EmployeesReport() {
  const [filters, setFilters] = useState<any>({});
  const [getListDocuments, setGetListDocuments] = useState(false);
  const [localFilters, setLocalFilters] = useState<any>({});
  const [exportData, setExportData] = useState<any>({});
  const [typeReport, setTypeReport] = useState("audit");
  const [listDocuments, setListDocuments] = useState<any[]>([]);
  const [customLoading, setCustomLoading] = useState(true);
  const [nextPage, setNextPage] = useState<any>(false);
  const [scrollDown, setScrollDown] = useState(false);
  const [reRenderFilterSettings, setReRenderFilterSettings] = useState(false);
  const [filtersParams, setFiltersParams] = useState({});
  const [defaultUserFilter, setDefaultUserFilter] = useState<any>(null);
  const [userFilterCheck, setUserFilterCheck] = useState(false);
  const [reRenderUserFilter, setReRenderUserFilter] = useState(null);
  const [displayFilters, setDisplayFilters] = useState<any>({});
  const [displayFiltersStr, setDisplayFiltersStr] = useState<any>("");
  const dispatch = useAppDispatch();
  const [openImportExel, setOpenImportExel] = useState(false);
  const [allLoading, setAllLoading] = useState(false);
  const [tableHeaderContentDownload, setTableHeaderContentDownload] = useState<any>({
    Code: {
      title: "Код документа",
      width: 50,
    },
    Title: {
      title: "Название документа",
      width: 50,
    },
    Ver: {
      title: "Версия документа",
      width: 50,
    },
    Created: {
      title: "Дата скачивания документа",
      width: 50,
    },
    ActiveType: {
      title: "Тип",
      width: 50,
    },
  });
  const [tableHeaderContentOwd, setTableHeaderContentOwd] = useState<any>({
    Code: {
      title: "Код документа",
      width: 50,
    },
    Title: {
      title: "Название документа",
      width: 50,
    },
    Expert: {
      title: "Кто провел OWD",
      width: 50,
    },
    Employee: {
      title: "Кому провели OWD",
      width: 50,
    },
    Ver: {
      title: "Версия документа",
      width: 50,
    },
    TemplateOWDTitle: {
      title: "Шаблон OWD",
      width: 50,
    },
    Created: {
      title: "Дата назначения  OWD",
      width: 50,
    },
    Author: {
      title: "Кем назначено",
      width: 50,
    },
    ReviewDate: {
      title: "Срок для проведения OWD",
      width: 50,
    },
    Status: {
      title: "Статус",
      width: 50,
    },
    Completed: {
      title: "Дата факта проведения OWD",
      width: 50,
    },
    TestAnswerRate: {
      title: "Результат OWD",
      width: 50,
    },
  });
  const [tableHeaderContentAudit, setTableHeaderContentAudit] = useState<any>({
    Code: {
      title: "Код документа",
      width: 50,
    },
    Title: {
      title: "Название документа",
      width: 50,
    },
    Ver: {
      title: "Версия документа",
      width: 50,
    },
    Created: {
      title: "Дата отправки на ознакомление",
      width: 50,
    },
    ReviewDate: {
      title: "Срок для ознакомления",
      width: 50,
    },
    Completed: {
      title: "Дата факта ознакомления",
      width: 50,
    },
    Status: {
      title: "Статус",
      width: 50,
    },
    TestAnswerRate: {
      title: "Результат тестирования",
      width: 50,
    },
  });
  const [templatesOWD, setTemplatesOWD] = useState<any>([]);

  useEffect(() => {
    getItemsRequest({ listName: templatesOWDListName }).then((results) => {
      setTemplatesOWD([...results.items]);
    });
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    if (Object.keys(filters).length > 0) {
      setCustomLoading(true);
      setListDocuments([]);
      setNextPage(null);
      setScrollDown(false);
      getItemsRequest({
        listName: myDocumentsEmployeeReportRelationsListName,
        rowLimit: Object.keys(localFilters).length > 0 && 1000 || 500,
        filters,
        sortOrder: { name: "ID", desc: true },
        signal: controller.signal,
        otherParams: { localFilters, typeReport }
      }).then((results) => {
        const { items, nextPage } = results;
        if (items.length > 0) {
          let emails: any = [];
          items.map((item: any) => {
            if (item.AuthorEmail) {
              emails = [...emails, item.AuthorEmail];
            }
            if (item.ResponsibleForRevisionEmail) {
              emails = [...emails, item.ResponsibleForRevisionEmail];
            }
            item.notifications.forEach((n: any) => {
              if (n.AuthorEmail) {
                emails = [...emails, n.AuthorEmail];
              }
              if (n.TestedEmployee) {
                emails = [...emails, n.TestedEmployee];
              }
              if (n.EmployeeEmail) {
                emails = [...emails, n.EmployeeEmail];
              }
            });
            item.downloads.forEach((n: any) => {
              if (n.AuthorEmail) {
                emails = [...emails, n.AuthorEmail];
              }
            });
          });
          dispatch(addUsers(emails));
          setListDocuments([...items]);
          setGetListDocuments(true);
          setNextPage(nextPage);
        }
        setCustomLoading(false);
      });
    }
    return () => controller.abort();
  }, [JSON.stringify(filters), typeReport, JSON.stringify(localFilters)]);

  useEffect(() => {
    if (nextPage && getListDocuments && scrollDown && Object.keys(filters).length > 0) {
      getItemsRequest({
        listName: myDocumentsEmployeeReportRelationsListName,
        rowLimit: Object.keys(localFilters).length > 0 && 1000 || 500,
        filters,
        sortOrder: { name: "ID", desc: true },
        nextPage,
        otherParams: { localFilters, typeReport }
      }).then((results) => {
        const { items, nextPage } = results;
        if (items.length > 0) {
          let emails: any = [];
          items.map((item: any) => {
            if (item.AuthorEmail) {
              emails = [...emails, item.AuthorEmail];
            }
            if (item.ResponsibleForRevisionEmail) {
              emails = [...emails, item.ResponsibleForRevisionEmail];
            }
            item.notifications.forEach((n: any) => {
              if (n.AuthorEmail) {
                emails = [...emails, n.AuthorEmail];
              }
              if (n.TestedEmployee) {
                emails = [...emails, n.TestedEmployee];
              }
              if (n.EmployeeEmail) {
                emails = [...emails, n.EmployeeEmail];
              }
            });
            item.downloads.forEach((n: any) => {
              if (n.AuthorEmail) {
                emails = [...emails, n.AuthorEmail];
              }
            });
          });
          dispatch(addUsers(emails));
          setListDocuments((prevState: any) => [...prevState, ...items]);
          setNextPage(nextPage);
          setScrollDown(false);
        }
      });
    }
  }, [nextPage, scrollDown, JSON.stringify(filters), getListDocuments]);

  useEffect(() => {
    let tempStr = "";
    Object.keys(displayFilters).map((key: string, idx: number) => {
      if (idx <= 3) {
        if (Array.isArray(displayFilters[key])) {
          displayFilters[key].map((item: string, idx: number) => {
            if (displayFilters[key].length - 1 === idx) {
              tempStr += item;
            } else {
              tempStr += `${item}, `;
            }
          });
        } else {
          tempStr += `${displayFilters[key]}`;
        }
        tempStr += ", ";
      }
    });
    tempStr = tempStr.slice(0, -2);
    if (Object.keys(displayFilters).length > 4) {
      tempStr += `...ещё ${Object.keys(displayFilters).length - 4}`;
    }
    setDisplayFiltersStr(tempStr);
  }, [displayFilters]);

  useEffect(() => {
    if (openImportExel) {
      setAllLoading(true);
      async function fetchData() {
        const importFilter = { ...filters };
        const results = await getItemsRequest({
          listName: myDocumentsEmployeeReportRelationsListName,
          rowLimit: 1000000,
          filters: importFilter,
          sortOrder: { name: "ID", desc: true },
          otherParams: { localFilters, typeReport }
        });
        const { items } = results;
        if (items.length > 0) {
          let exportColumns: any = [];
          let tableHeaderContentExel: any;
          if (typeReport === 'owd') {
            tableHeaderContentExel = tableHeaderContentOwd
          }
          if (typeReport === 'audit') {
            tableHeaderContentExel = tableHeaderContentAudit
          }
          if (typeReport === 'download') {
            tableHeaderContentExel = tableHeaderContentDownload
          }
          Object.keys(tableHeaderContentExel).map((key: any) => {
            exportColumns = [
              ...exportColumns,
              {
                header: tableHeaderContentExel[key]["title"],
                key: key,
                width: tableHeaderContentExel[key]["width"],
              },
            ];
          });
          let exportTemp: any = [];
          const downloads = items.map(
            (document: any) => document.downloads
          ).flat();
          const notifications = items.map(
            (document: any) => document.notifications
          ).flat();
          if (typeReport === 'download') {
            downloads.forEach((item: any) => {
              exportTemp = [
                ...exportTemp,
                {
                  Code: {
                    text: `${item.DocumentCode}`,
                    hyperlink: `${siteUrl}/dashboard/1/reports/5?documentCard=${item.Document.id}`,
                  },
                  Title: item.Document.Title,
                  Ver: item.Ver,
                  Created: moment(item.Created).format("DD.MM.YYYY hh:mm"),
                  ActiveType: item.ActiveType,
                },
              ];
            });
          }
          if (typeReport === 'audit') {
            notifications.forEach((item: any) => {
              exportTemp = [
                ...exportTemp,
                {
                  Code: {
                    text: `${item.DocumentCode}`,
                    hyperlink: `${siteUrl}/dashboard/1/reports/5?documentCard=${item.Document.id}`,
                  },
                  Title: item.Document.Title,
                  Ver: ((item.VersionDocument && item.VersionDocument.Ver) || (item.Document && item.Document.Ver) || 1),
                  Created: moment(item.Created).format("DD.MM.YYYY"),
                  ReviewDate: moment(item.ReviewDate).format("DD.MM.YYYY"),
                  Completed:
                    (item.Completed && moment(item.Completed).format("DD.MM.YYYY")) ||
                    "-",
                  Status: item.Title.includes("Отклонено")
                    ? "Отклонено"
                    : (item.Completed && "Ознакомлен") || "Не ознакомлен",
                  TestAnswerRate:
                    (item.TestAnswerRate && item.TestAnswerRate + "%") || "-",
                },
              ];
            });
          }

          if (typeReport === 'owd') {
            notifications.forEach((item: any) => {
              exportTemp = [
                ...exportTemp,
                {
                  Code: {
                    text: `${item.DocumentCode}`,
                    hyperlink: `${siteUrl}/dashboard/1/reports/5?documentCard=${item.Document.id}`,
                  },
                  Title: item.Document.Title,
                  Ver: ((item.VersionDocument && item.VersionDocument.Ver) || (item.Document && item.Document.Ver) || 1),
                  Created: moment(item.Created).format("DD.MM.YYYY"),
                  ReviewDate: moment(item.ReviewDate).format("DD.MM.YYYY"),
                  Completed:
                    (item.Completed && moment(item.Completed).format("DD.MM.YYYY")) ||
                    "-",
                  Status: ((item.Title.includes("Отклонено") && "Отклонено") || (!item.isPass && !item.Title.includes("Отклонено") && item.TestAnswerRate === 0 && "Не проведено") || (!item.isPass && !item.Title.includes("Отклонено") && item.TestAnswerRate > 0 && "Не сдано") || (item.isPass && "Сдано")),
                  Author: item.AuthorEmail,
                  Expert: item.EmployeeEmail,
                  Employee: item.TestedEmployee,
                  TemplateOWDTitle:
                    (item.TemplateOWDID &&
                      templatesOWD.filter(
                        (template: any) => template.ID === item.TemplateOWDID
                      ).length > 0 &&
                      templatesOWD.filter(
                        (template: any) => template.ID === item.TemplateOWDID
                      )[0]["Title"]) ||
                    "-",
                  TestAnswerRate:
                    (item.TestAnswerRate && item.TestAnswerRate + "%") || "-",
                },
              ];
            });
          }

          const exportData = { columns: [...exportColumns], data: [...exportTemp] };
          const fileName = "Employee Report";
          const type = "employees_report";
          setAllLoading(false);
          exportExcelFile(exportData, fileName, type, setOpenImportExel);
          setOpenImportExel(false);
        } else {
          setAllLoading(false);
          setOpenImportExel(false);
        }
      }
      fetchData();
    }
  }, [openImportExel]);

  return (
    <LayoutWithAsideAndContent
      aside={
        <FlexCol className="h-full overflow-y-auto scrollbar scrollbar-w-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB]">
          <EmployeesReportFilters
            setFilters={setFilters}
            setGetListDocuments={setGetListDocuments}
            setLocalFilters={setLocalFilters}
            typeReport={typeReport}
            filtersParams={filtersParams}
            defaultUserFilter={defaultUserFilter}
            setFiltersParams={setFiltersParams}
            userFilterCheck={userFilterCheck}
            reRenderUserFilter={reRenderUserFilter}
            setDisplayFilters={setDisplayFilters}
          />
        </FlexCol>
      }
      content={
        <FlexCol className="w-full">
          <FlexRow className="px-7.5 h-[76px] border-b justify-between items-center shrink-0 w-full gap-5">
            <FlexRow className="items-center justify-between gap-5 w-full">
              <nav
                className="flex justify-between w-full"
                aria-label="Breadcrumb"
              >
                <FlexCol className="grow">
                  <ol className="inline-flex items-center">
                    <li
                      className="inline-flex items-center"
                      aria-current="page"
                    >
                      <Link
                        to="/dashboard/1/reports"
                        className="inline-flex items-center space-x-2 text-base font-medium cursor-pointer"
                      >
                        <ReportIcon />
                        <span>Отчеты</span>
                      </Link>
                      <span className="px-3 text-body-color">
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16.2 8.55001L10.3781 2.64376C10.125 2.39064 9.73126 2.39064 9.47813 2.64376C9.22501 2.89689 9.22501 3.29064 9.47813 3.54376L14.2031 8.35314H2.25001C1.91251 8.35314 1.63126 8.63439 1.63126 8.97189C1.63126 9.30939 1.91251 9.61876 2.25001 9.61876H14.2594L9.47813 14.4844C9.22501 14.7375 9.22501 15.1313 9.47813 15.3844C9.59063 15.4969 9.75938 15.5531 9.92813 15.5531C10.0969 15.5531 10.2656 15.4969 10.3781 15.3563L16.2 9.45001C16.4531 9.19689 16.4531 8.80314 16.2 8.55001Z"
                            fill={"#637381"}
                          />
                        </svg>
                      </span>
                    </li>
                    <li
                      className="inline-flex items-center"
                      aria-current="page"
                    >
                      <div className="inline-flex items-center space-x-2 text-base font-medium cursor-pointer">
                        <GroupIcon />
                        <span>Отчет по сотрудникам</span>
                      </div>
                    </li>
                  </ol>
                </FlexCol>
              </nav>
              <FlexRow className="items-center gap-2">
                <FavoriteButtonFilters filters={Object.keys(filters).length > 0 && JSON.stringify(filters) || ""} displayFilters={Object.keys(displayFilters).length > 0 && JSON.stringify(displayFilters) || ""} reRenderFilterSettings={reRenderFilterSettings} setReRenderFilterSettings={setReRenderFilterSettings} filtersParams={Object.keys(filtersParams).length > 0 && JSON.stringify(filtersParams) || ""} type='employe_report' />
                <FavoriteFiltersList reRenderTableFlag={setGetListDocuments} reRenderFilterSettings={reRenderFilterSettings} setReRenderFilterSettings={setReRenderFilterSettings} setFiltersParams={setFiltersParams} type='employe_report' filtersParams={Object.keys(filtersParams).length > 0 && JSON.stringify(filtersParams) || ""} listQuestions={myDocumentsListName} setDefaultUserFilter={setDefaultUserFilter} setUserFilterCheck={setUserFilterCheck} userFilterCheck={userFilterCheck} setReRenderUserFilter={setReRenderUserFilter} />
              </FlexRow>
            </FlexRow>
            <Button
              classBg="btn-white min-w-[200px]"
              shadow={true}
              typeIcon="download"
              icon={true}
              text="Скачать в Excel"
              open={openImportExel}
              setOpen={setOpenImportExel}
            />
          </FlexRow>
          <FlexRow className="px-7.5 pt-7.5">
            <FlexCol className="gap-5 w-full">
              <FlexRow className="gap-2 p-1.5 shadow-custom bg-white w-full rounded">
                <FlexCol
                  onClick={() => setTypeReport("audit")}
                  className={twMerge(
                    "items-center py-2 px-5 cursor-pointer w-1/3",
                    (typeReport === "audit" && "text-[#012169] font-bold") ||
                    "text-[#637381]"
                  )}
                >
                  Ознакомление
                </FlexCol>
                <FlexCol
                  onClick={() => setTypeReport("owd")}
                  className={twMerge(
                    "items-center py-2 px-5 cursor-pointer w-1/3",
                    (typeReport === "owd" && "text-[#012169] font-bold") ||
                    "text-[#637381]"
                  )}
                >
                  OWD
                </FlexCol>
                <FlexCol
                  onClick={() => setTypeReport("download")}
                  className={twMerge(
                    "items-center py-2 px-5 cursor-pointer w-1/3",
                    (typeReport === "download" && "text-[#012169] font-bold") ||
                    "text-[#637381]"
                  )}
                >
                  Скачивания
                </FlexCol>
              </FlexRow>
              {typeReport === "audit" && (
                <AuditEmplyeesTable setExportData={setExportData} data={listDocuments.map(
                  (document: any) => document.notifications
                ).flat()} setScrollDown={setScrollDown} filters={filters} customLoading={customLoading} />
              )}
              {typeReport === "owd" && (
                <OwdEmployeesTable setExportData={setExportData} data={listDocuments.map(
                  (document: any) => document.notifications
                ).flat()} setScrollDown={setScrollDown} filters={filters} customLoading={customLoading} />
              )}
              {typeReport === "download" && (
                <DownloadEmployesTable
                  exportData={exportData}
                  setExportData={setExportData}
                  data={listDocuments.map(
                    (document: any) => document.downloads
                  ).flat()}
                  setScrollDown={setScrollDown}
                  filters={filters}
                  customLoading={customLoading}
                />
              )}
            </FlexCol>
          </FlexRow>
          <Modal zIndex={120} open={openImportExel} toggleDialog={setOpenImportExel} modalClassName="min-h-px">
            {allLoading && (
              <FlexCol className="gap-5 justify-center items-center mt-3">
                <Loading />
                <span>
                  Готовим файл для скачивания <br />
                  Пожалуйста подождите...
                </span>
              </FlexCol>
            )}
          </Modal>
        </FlexCol>
      }
    />
  );
}
